import { namespace as hyperlinksNamespace } from "../modules/hyperlinks/hyperlinks";
import { Store } from "vuex";
import { HyperlinkItem } from "@/types/HyperlinkItem";

export class HyperlinksStore {
    private store: Store<any>;

    constructor(store: Store<any>) {
        this.store = store;
    }

    public async createHyperlink(hyperlink: HyperlinkItem): Promise<string> {
        return this.store.dispatch(`${hyperlinksNamespace}/createHyperlink`, hyperlink);
    }
}
